
import { useState, useEffect } from "react";

export default function Users({ supabase }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => { loadUsers(); }, []);

  async function loadUsers() {
    const { data } = await supabase.from("profiles").select("*").order("created_at", { ascending: false });
    if (data) setUsers(data);
    setLoading(false);
  }

  const filtered = users.filter(u => !search || u.full_name?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase()) || u.phone?.includes(search));

  return (
    <div>
      <div style={{ display: "flex", gap: 16, marginBottom: 20, alignItems: "center" }}>
        <input style={{ background: "#111", border: "1px solid #333", borderRadius: 8, padding: "10px 16px", color: "#fff", fontSize: 14, width: 320 }} placeholder="Search by name, email or phone..." value={search} onChange={e => setSearch(e.target.value)} />
        <span style={{ color: "#666", fontSize: 14 }}>{filtered.length} users</span>
      </div>
      {loading ? <div style={{ color: "#666", textAlign: "center", padding: 40 }}>Loading users...</div> : (
        <div style={{ background: "#111", border: "1px solid #222", borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>{["Name", "Email", "Phone", "Wallet Balance", "Joined", "Notifications"].map(h => <th key={h} style={{ color: "#666", fontSize: 12, fontWeight: "600", textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #222", textTransform: "uppercase", background: "#0a0a0a" }}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {filtered.map(user => (
                <tr key={user.id} style={{ borderBottom: "1px solid #1a1a1a" }}>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>
                    <span style={{ width: 32, height: 32, borderRadius: "50%", background: "#00A65130", color: "#00A651", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", marginRight: 10, fontSize: 14 }}>{user.full_name?.[0] || "?"}</span>
                    <span style={{ fontWeight: "500", color: "#fff" }}>{user.full_name || "N/A"}</span>
                  </td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{user.email || "N/A"}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{user.phone || "N/A"}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>Le {user.wallet_balance?.toLocaleString() || "0"}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{new Date(user.created_at).toLocaleDateString()}</td>
                  <td style={{ fontSize: 14, padding: "12px 16px", color: user.push_token ? "#00A651" : "#666" }}>{user.push_token ? "✅ Active" : "❌ None"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
